import styled from "styled-components";
import { breakpoints, sizes } from "styles";

export const UspSectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 16px;
  gap: 33px;
  background: ${({ theme }) => theme.colors.white};
  max-width: ${sizes.containerWidth};
  margin: 0 auto;

  @media ${breakpoints.mobile} {
    padding: 40px 16px;
    gap: 24px;
  }
`;

export const UspTitle = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  font-size: 36px;
  line-height: 46px;
  text-align: center;
  color: ${({ theme }) => theme.colors.black["100"]};
  margin: 0;

  @media ${breakpoints.mobile} {
    font-size: 24px;
    line-height: 32px;
  }
`;

export const UspCardsRow = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;

  @media ${breakpoints.mobile} {
    flex-direction: column;
    align-items: stretch;
    gap: 24px;
    padding: 0 16px;
    box-sizing: border-box;
  }
`;

export const UspCard = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  padding: 32px;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 16px;
  box-shadow: 0px 4px 15.25px rgba(0, 0, 0, 0.1);

  @media ${breakpoints.mobile} {
    flex: none;
    padding: 24px;
    width: 100%;
    box-sizing: border-box;
  }
`;

export const UspCardTitle = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  font-size: 25px;
  line-height: 33px;
  text-align: center;
  color: ${({ theme }) => theme.colors.black["100"]};
  margin: 0;
  width: 100%;
`;

export const UspCardSubtitle = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  font-size: 18px;
  line-height: 33px;
  text-align: center;
  color: ${({ theme }) => theme.colors.black["100"]};
  margin: 0;
  width: 100%;
`;

export const UspCardImage = styled.div<{ $objectPosition?: string }>`
  width: 100%;
  height: 233px;
  border-radius: 30px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;

  img {
    object-fit: cover;
    object-position: ${({ $objectPosition }) => $objectPosition || "center"};
  }
`;

export const UspCardBullets = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const UspBulletItem = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  width: 100%;
`;

export const UspBulletIcon = styled.div`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
`;

export const UspBulletText = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  color: ${({ theme }) => theme.colors.black["100"]};
  margin: 0;
  flex: 1;
  min-width: 0;

  @media ${breakpoints.mobile} {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const UspPlusSeparator = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50px;
  flex-shrink: 0;
  border-radius: 16px;
  filter: drop-shadow(0px 0px 34px rgba(232, 100, 31, 0.16));

  span {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-weight: 700;
    font-size: 50px;
    line-height: 40px;
    text-align: center;
    color: #173fa8;
  }

  @media ${breakpoints.mobile} {
    width: 40px;
    align-self: center;
    span {
      font-size: 36px;
    }
  }
`;

export const UspBracketArrow = styled.div`
  width: 736px;
  height: 101px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
  }

  @media ${breakpoints.mobile} {
    display: none;
  }
`;

export const UspMobileArrow = styled.div`
  display: none;
  width: 76px;
  height: 60px;

  img {
    width: 100%;
    height: 100%;
  }

  @media ${breakpoints.mobile} {
    display: block;
  }
`;

export const UspOutcomeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  width: 100%;
`;

export const UspOutcomeYellow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  > div {
    flex: 1;
    min-width: 0;
    background: ${({ theme }) => theme.colors.yellow["500"]};
    border-radius: 16px;
    padding: 32px;
    filter: drop-shadow(0px 0px 34px rgba(0, 146, 116, 0.16));
  }

  p {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-weight: 700;
    font-size: 28px;
    line-height: 40px;
    text-align: center;
    color: ${({ theme }) => theme.colors.black["100"]};
    margin: 0;
  }

  @media ${breakpoints.mobile} {
    > div {
      padding: 20px;
    }
    p {
      font-size: 20px;
      line-height: 30px;
    }
  }
`;

export const UspDownArrow = styled.div`
  width: 76px;
  height: 60px;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const UspOutcomeWhite = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  > div {
    flex: 1;
    min-width: 0;
    background: ${({ theme }) => theme.colors.white};
    border-radius: 16px;
    padding: 32px;
    filter: drop-shadow(0px 0px 34px rgba(44, 44, 49, 0.1));
  }

  p {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-size: 28px;
    line-height: 40px;
    text-align: center;
    color: ${({ theme }) => theme.colors.black["100"]};
    margin: 0;
  }

  .bold {
    font-weight: 700;
  }

  .regular {
    font-weight: 400;
  }

  @media ${breakpoints.mobile} {
    > div {
      padding: 20px;
    }
    p {
      font-size: 20px;
      line-height: 30px;
    }
  }
`;
